import * as z from "zod";
//#region src/__generated__/project-gge/projectController/zod/projectMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectMetaDtoSchema = z.object({
	key: z.string(),
	value: z.string()
}).describe("Project metadata object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectCreationDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectCreationDtoSchema = z.object({
	authorId: z.uuid().optional(),
	description: z.string().optional(),
	documentationId: z.uuid().optional(),
	endDate: z.iso.datetime().optional(),
	id: z.uuid().optional(),
	isArchived: z.boolean().optional(),
	lat: z.number().optional(),
	lon: z.number().optional(),
	meta: z.array(projectMetaDtoSchema).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional(),
	objectName: z.string().optional(),
	projectCostAtStart: z.number().optional(),
	realisationCost: z.number().optional(),
	stage: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional(),
	startDate: z.iso.datetime().optional(),
	status: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional().describe("Dummy enum. Copy of 'stage' field for now."),
	templateId: z.uuid().optional(),
	title: z.string(),
	totalCost: z.number().optional(),
	type: z.enum([
		"LINEAR",
		"PLANAR",
		"SIMPLE"
	])
}).describe("Project object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectTemplateMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectTemplateMetaDtoSchema = z.object({
	id: z.uuid().nullish(),
	key: z.string().nullish(),
	templateId: z.uuid().nullish(),
	value: z.string().nullish()
}).describe("Project template metadata object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectTemplateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectTemplateDtoSchema = z.object({
	endDate: z.iso.datetime().optional().describe("Unix-time in seconds"),
	externalId: z.string().optional().describe("На данный момент - id в СПИУИ"),
	id: z.uuid(),
	isProjectStarted: z.boolean().optional(),
	lat: z.number().optional(),
	lon: z.number().optional(),
	meta: z.array(projectTemplateMetaDtoSchema).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional(),
	objectName: z.string().optional().describe("Наименование объекта строительства"),
	projectCostAtStart: z.number().optional(),
	realisationCost: z.number().optional(),
	startDate: z.iso.datetime().optional().describe("Unix-time in seconds"),
	templateName: z.string(),
	totalCost: z.number().optional(),
	type: z.enum([
		"LINEAR",
		"PLANAR",
		"SIMPLE"
	])
}).describe("Project template object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/createProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createProjectStatus200Schema = projectCreationDtoSchema.describe("Project object.");
const createProjectResponseSchema = createProjectStatus200Schema;
const createProjectDataSchema = projectTemplateDtoSchema.describe("Project template object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/createProjectWithoutTemplateSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createProjectWithoutTemplateStatus200Schema = projectCreationDtoSchema.describe("Project object.");
const createProjectWithoutTemplateResponseSchema = createProjectWithoutTemplateStatus200Schema;
const createProjectWithoutTemplateDataSchema = projectCreationDtoSchema.omit({
	authorId: true,
	documentationId: true,
	id: true,
	stage: true,
	status: true
}).describe("Project object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/deleteProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteProjectPathProjectIdSchema = z.uuid();
const deleteProjectStatus200Schema = z.unknown();
const deleteProjectResponseSchema = deleteProjectStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectDtoSchema = z.object({
	authorId: z.uuid().nullish(),
	createdAt: z.iso.datetime().nullish(),
	description: z.string().nullish(),
	documentationId: z.uuid().nullish(),
	endDate: z.iso.datetime().nullish(),
	id: z.uuid().nullish(),
	isArchived: z.boolean(),
	isDeleted: z.boolean(),
	lat: z.number().nullish(),
	lon: z.number().nullish(),
	modifiedAt: z.iso.datetime().nullish(),
	objectName: z.string().nullish(),
	projectCostAtStart: z.number().nullish(),
	realisationCost: z.number().nullish(),
	stage: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional(),
	startDate: z.iso.datetime().nullish(),
	status: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional().describe("Dummy enum. Copy of 'stage' field for now."),
	templateId: z.uuid().nullish(),
	title: z.string().nullish(),
	totalCost: z.number().nullish(),
	type: z.enum([
		"LINEAR",
		"PLANAR",
		"SIMPLE"
	])
}).describe("Project object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/getAllProjectsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAllProjectsStatus200Schema = z.array(projectDtoSchema);
const getAllProjectsResponseSchema = getAllProjectsStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectController/zod/getByIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getByIdPathProjectIdSchema = z.uuid();
const getByIdStatus200Schema = projectDtoSchema.describe("Project object.");
const getByIdResponseSchema = getByIdStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectController/zod/dataBufferSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dataBufferSchema = z.object({});
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectSearchPatternSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectSearchPatternSchema = z.object({
	pattern: z.enum([
		"CONTAINS",
		"RANGE",
		"EQUALS"
	]).optional().describe("Тип шаблона поиска."),
	value: z.array(z.string()).nullish().describe("Значение критерия поиска.")
}).describe("Критерии поиска, где ключи - названия полей, а значения - объекты ProjectSearchPattern. Возможные поля:\n'title' - название проекта,\n'objectName' - организация,\n'meta' - номер проекта,\n'startDate' - дата начала проекта.\n");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectSearchDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectSearchDtoSchema = z.object({
	page: z.int().describe("Номер страницы для пагинации (нумерация начинается с 1)."),
	searchPatterns: z.object({}).catchall(projectSearchPatternSchema).optional().describe("Критерии поиска, где ключи - названия полей, а значения - объекты ProjectSearchPattern. Возможные поля:\n'title' - название проекта,\n'objectName' - организация,\n'meta' - номер проекта,\n'startDate' - дата начала проекта.\n"),
	size: z.int().describe("Размер страницы (количество элементов на странице)."),
	sortBy: z.enum([
		"ID",
		"TITLE",
		"CREATED_AT",
		"ORGANIZATION",
		"MODIFIED_AT",
		"DELETED_AT",
		"IS_DELETED",
		"AUTHOR_ID",
		"TEMPLATE_ID",
		"DESCRIPTION",
		"START_DATE",
		"END_DATE",
		"LAT",
		"LON",
		"TOTAL_COST",
		"REALISATION_COST",
		"DOCUMENTATION_ID",
		"STAGE",
		"STATUS",
		"TYPE",
		"IS_ARCHIVED",
		"EXTERNAL_ID",
		"MAIN_TITLE"
	]).optional().describe("Поле, по которому будет выполнена сортировка."),
	sortDirection: z.enum(["ASC", "DESC"]).optional().describe("Направление сортировки: ASC (возрастание) или DESC (убывание).")
}).describe("Search object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/getExcelReportProjectsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getExcelReportProjectsQueryIsArchiveSchema = z.boolean().optional();
const getExcelReportProjectsStatus200Schema = z.array(dataBufferSchema);
const getExcelReportProjectsResponseSchema = getExcelReportProjectsStatus200Schema;
const getExcelReportProjectsDataSchema = projectSearchDtoSchema.describe("Search object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/getProjectByIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getProjectByIdPathIdSchema = z.uuid();
const getProjectByIdStatus200Schema = projectDtoSchema.describe("Project object.");
const getProjectByIdResponseSchema = getProjectByIdStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectWithMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectWithMetaDtoSchema = z.object({
	authorId: z.uuid().nullish(),
	createdAt: z.iso.datetime().nullish(),
	description: z.string().nullish(),
	documentationId: z.uuid().nullish(),
	endDate: z.iso.datetime().nullish(),
	id: z.uuid().nullish(),
	isArchived: z.boolean(),
	isDeleted: z.boolean(),
	lat: z.number().nullish(),
	lon: z.number().nullish(),
	meta: z.array(projectMetaDtoSchema).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).nullish(),
	modifiedAt: z.iso.datetime().nullish(),
	objectName: z.string().nullish(),
	projectCostAtStart: z.number().nullish(),
	realisationCost: z.number().nullish(),
	stage: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional(),
	startDate: z.iso.datetime().nullish(),
	status: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional().describe("Dummy enum. Copy of 'stage' field for now."),
	templateId: z.uuid().nullish(),
	title: z.string().nullish(),
	totalCost: z.number().nullish(),
	type: z.enum([
		"LINEAR",
		"PLANAR",
		"SIMPLE"
	])
}).describe("Объект проекта, в котором присутствует мета. Используется только при получении проектов пользователя для корректного отображения карточки проекта.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/getProjectByIdsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getProjectByIdsQueryProjectIdsSchema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
const getProjectByIdsStatus200Schema = z.array(projectWithMetaDtoSchema);
const getProjectByIdsResponseSchema = getProjectByIdsStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectController/zod/assignedUserDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const assignedUserDtoSchema = z.object({ userId: z.uuid().nullish() });
//#endregion
//#region src/__generated__/project-gge/projectController/zod/roleCacheDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const roleCacheDtoSchema = z.object({
	assignedUsers: z.array(assignedUserDtoSchema).nullish(),
	projectId: z.uuid().nullish()
});
//#endregion
//#region src/__generated__/project-gge/projectController/zod/getProjectUsersSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getProjectUsersPathProjectIdSchema = z.uuid();
const getProjectUsersStatus200Schema = roleCacheDtoSchema;
const getProjectUsersResponseSchema = getProjectUsersStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectController/zod/projectUpdateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectUpdateDtoSchema = z.object({
	description: z.string().optional(),
	documentationId: z.uuid().optional(),
	endDate: z.iso.datetime().optional(),
	id: z.uuid().optional(),
	isArchived: z.boolean().optional(),
	lat: z.number().optional(),
	lon: z.number().optional(),
	objectName: z.string().optional(),
	projectCostAtStart: z.number().optional(),
	realisationCost: z.number().optional(),
	stage: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional(),
	startDate: z.iso.datetime().optional(),
	status: z.enum([
		"NOT_STARTED",
		"ACTIVE",
		"DONE"
	]).optional().describe("Dummy enum. Copy of 'stage' field for now."),
	templateId: z.uuid().optional(),
	title: z.string().optional(),
	totalCost: z.number().optional(),
	type: z.enum([
		"LINEAR",
		"PLANAR",
		"SIMPLE"
	])
}).describe("Project update object.");
//#endregion
//#region src/__generated__/project-gge/projectController/zod/updateProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateProjectStatus200Schema = projectDtoSchema.describe("Project object.");
const updateProjectResponseSchema = updateProjectStatus200Schema;
const updateProjectDataSchema = projectUpdateDtoSchema.describe("Project update object.");
//#endregion
export { deleteProjectPathProjectIdSchema as A, projectTemplateMetaDtoSchema as B, dataBufferSchema as C, getAllProjectsResponseSchema as D, getByIdStatus200Schema as E, createProjectWithoutTemplateStatus200Schema as F, projectMetaDtoSchema as H, createProjectDataSchema as I, createProjectResponseSchema as L, deleteProjectStatus200Schema as M, createProjectWithoutTemplateDataSchema as N, getAllProjectsStatus200Schema as O, createProjectWithoutTemplateResponseSchema as P, createProjectStatus200Schema as R, projectSearchPatternSchema as S, getByIdResponseSchema as T, projectCreationDtoSchema as V, getExcelReportProjectsDataSchema as _, getProjectUsersPathProjectIdSchema as a, getExcelReportProjectsStatus200Schema as b, roleCacheDtoSchema as c, getProjectByIdsResponseSchema as d, getProjectByIdsStatus200Schema as f, getProjectByIdStatus200Schema as g, getProjectByIdResponseSchema as h, projectUpdateDtoSchema as i, deleteProjectResponseSchema as j, projectDtoSchema as k, assignedUserDtoSchema as l, getProjectByIdPathIdSchema as m, updateProjectResponseSchema as n, getProjectUsersResponseSchema as o, projectWithMetaDtoSchema as p, updateProjectStatus200Schema as r, getProjectUsersStatus200Schema as s, updateProjectDataSchema as t, getProjectByIdsQueryProjectIdsSchema as u, getExcelReportProjectsQueryIsArchiveSchema as v, getByIdPathProjectIdSchema as w, projectSearchDtoSchema as x, getExcelReportProjectsResponseSchema as y, projectTemplateDtoSchema as z };

//# sourceMappingURL=updateProjectSchema2.js.map